konnyScript(function($){

  var styletipSlide = new Swiper('#styletip_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      //loop: true,
      scrollbar: {
          el: '#styletip_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#styletip_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#styletip_swiper_slide1 .swiper-button-next',
          prevEl: '#styletip_swiper_slide1 .swiper-button-prev',
      },
  });
  
  var sTipSlide = new Swiper('#sTip_swiper_slide1',{
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10,
    //loop: true,
    scrollbar: {
      el: '#sTip_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#sTip_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#sTip_swiper_slide1 .swiper-button-next',
      prevEl: '#sTip_swiper_slide1 .swiper-button-prev',
    },
  });
  
  var spcSlide = new Swiper('#spc_swiper_slide1',{
    centeredSlides: true,
    speed:0,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination:true,
    pagination:{
      el:'#spc_swiper_slide1 .swiper-pagination',
        clickable:true,
    },
    scrollbar:{
      el:'#spc_swiper_slide1 .swiper-scrollbar',
      hide:true,
    },
  });
  
  /* 뉴컬러 화보 슬라이드 */
  $('[id^=\'nc_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var reviewSlide = new Swiper(this,{
      slidesPerView:1.19,
      slidesPerGroup:1,
      spaceBetween :'3%',
      centeredSlides:true,
      observer:true,
      observeParents:true,
      //loop: true,
      pagination:true,
      pagination:{
        el:slidePage1,
        clickable:true,
      },
      scrollbar:{
        el:slideScr,
        hide:true,
      },
    });
  });

  $('[id^=\'mall_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = this.querySelector('.swiper-pagination');
      var slidePage2 = this.querySelector('.swiper-progress');
      var slideScr = this.querySelector('.swiper-scrollbar');
      var slideNext = this.querySelector('.swiper-button-next');
      var slidePrev = this.querySelector('.swiper-button-prev');
      var mallSlide = new Swiper(this,{
          slidesPerView:1.19,
          slidesPerGroup:1,
          spaceBetween:'3%',
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
          navigation: {
              nextEl: slideNext,
              prevEl: slidePrev,
          },
      });
  });

  $('[id^=\'w_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = this.querySelector('.swiper-pagination');
      var slidePage2 = this.querySelector('.swiper-progress');
      var slideScr = this.querySelector('.swiper-scrollbar');
      var slideNext = this.querySelector('.swiper-button-next');
      var slidePrev = this.querySelector('.swiper-button-prev');
      var mallSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
      });
  });
    
  $('#k-prdWrap .conInfoWrap .conTop').click(function(){
    var onDiv = $(this).parents('.conInfoWrap');
    onDiv.toggleClass('on');
  });
  
  /* gif 슬라이드 */
  $('[id^=\'gif_swiper_slide\']').each(function(index){
    var gifSlide = new Swiper(this,{
      slidesPerView:1,
      slidesPerGroup:1,
      centeredSlides:true,
      loop:true,
      effect:'fade',
      speed:0,
      autoplay:{
        delay:1000,
        disableOnInteraction:false,
      },
    });
  });
    
  $('[id^=\'gif_swiperslide\']').each(function(index){
      var gifSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          loop:true,
          effect:'fade',
          speed:0,
          autoplay:{
              delay:700,
              disableOnInteraction:false,
          },
      });
  });
  
  $('[id^=\'gif_swiperslide\']').each(function(index){
      var gifSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          loop:true,
          effect:'fade',
          speed:0,
          autoplay:{
              delay:700,
              disableOnInteraction:false,
          },
      });
  });
  
    
  
  //전체싱품보기
  var allprdSlide = new Swiper('#k-prdWrap #allprd_swiper_slide',{
      slidesPerView:2.1,
      slidesPerGroup:1,
      spaceBetween:15,
      centeredSlides:false,
      observer:true,
      observeParents:true,
      //loop:true,
  });

  
    var gift_galleryTop = new Swiper('#setimg_swiper_slide1', {
        slidesPerView:1.02,
        slidesPerGroup:1,
        spaceBetween:10,
        pagination: {	//페이징 사용자 설정
            el: ".swiper-pagination",	//페이징 태그 클래스 설정 
            clickable: true,	//버튼 클릭 여부
            type : 'bullets',	//페이징 타입 설정(종류: bullets, fraction, progress, progressbar)
            // Bullet Numbering 설정
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },
        loop: false,	//슬라이드 반복
    });
     
});